// Lib imports
import axios from 'axios'

// const API_URL = 'http://192.168.1.17:3000';
// const API_URL = 'http://localhost:3000';
//const API_URL = 'https://store.emporiodasmarcas.com.br'
const API_URL = 'https://api-store.emporiodasmarcas.com.br';

var ax =  axios.create({
    baseURL: API_URL
});

ax.interceptors.response.use(
    response => {
        return response;  
    },
    error => {
        
        
        return Promise.reject(error.response.data)
    }
);

ax.interceptors.request.use( async config => {
    const user = JSON.parse(localStorage.getItem('usuario'));

    if(user && user.token){
        config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
});

export default ax;